define(function(require) {

    const PROD_SERVER_URL = "https://infogeo.education.gouv.qc.ca",
          DEV_SERVER_URL = "https://carto48dev.education.gouv.qc.ca",
          SERVER = document.location.origin === PROD_SERVER_URL ? "PROD" : "DEV",
          QUERY_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/PUBLIC_QUERY_SERVICES/GPServer",
          CARTOVISTA_DATA_URL = "../../public/data",
          LOGGER_SERVICES_URL = (SERVER === "PROD" ? PROD_SERVER_URL : DEV_SERVER_URL) + "/arcgis/rest/services/" + SERVER + "/LOGGER_SERVICES/GPServer";

    return {
        APP_NAME: "Atlas_Decrochage",
        URLS: {
            LOGGER: {
                LOG_CLIENT_ERROR: LOGGER_SERVICES_URL + "/LogClientError/execute"
            },
            QUERY_LAYERS : {
                GEO09E17_ARRND : CARTOVISTA_DATA_URL + "/GEO09E17_ARRND.json",
                GEO09E04_MUNCP_GEN: CARTOVISTA_DATA_URL + "/GEO09E04_MUNCP_GEN.json",
                GEO09E04_MUNCP: QUERY_SERVICES_URL + "/Query_GEO09E04_MUNCP/execute",
                GEO09E05_MRC_GEN: CARTOVISTA_DATA_URL + "/GEO09E05_MRC_GEN.json",
                GEO09E05_MRC: QUERY_SERVICES_URL + "/Query_GEO09E05_MRC/execute",
                GEO09E01_CS_FRA_STA_GEN: CARTOVISTA_DATA_URL + "/GEO09E01_CS_FRA_STA_GEN.json",
                GEO09E01_CS_FRA_STA: QUERY_SERVICES_URL + "/Query_GEO09E01_CS_FRA_STA/execute",
                GEO09E02_CS_ANG_STA_GEN: CARTOVISTA_DATA_URL + "/GEO09E02_CS_ANG_STA_GEN.json",
                GEO09E02_CS_ANG_STA: QUERY_SERVICES_URL + "/Query_GEO09E02_CS_ANG_STA/execute",
                GEO09E06_REG_ADM_GEN: CARTOVISTA_DATA_URL + "/GEO09E06_REG_ADM_GEN.json",
                GEO09E06_REG_ADM: QUERY_SERVICES_URL + "/Query_GEO09E06_REG_ADM/execute"
            },
        },
        LAYERS: {
            GEO09E17_ARRND: require("configs/layers/GEO09E17_ARRND"),
            GEO09E04_MUNCP_GEN: require("configs/layers/GEO09E04_MUNCP_GEN"),
            GEO09E05_MRC_GEN: require("configs/layers/GEO09E05_MRC_GEN"),
            GEO09E01_CS_FRA_STA_GEN: require("configs/layers/GEO09E01_CS_FRA_STA_GEN"),
            GEO09E02_CS_ANG_STA_GEN: require("configs/layers/GEO09E02_CS_ANG_STA_GEN"),
            GEO09E06_REG_ADM_GEN: require("configs/layers/GEO09E06_REG_ADM_GEN"),
        },
        MASTER_THEMESETS_ELEMENTS: {
            ANNEE_2023_2024: {
                ID: "2023_2024",
                TITLE: "Année scolaire 2023-2024",
                UPDATE_THEMES: true,
                THEMES_TEXT: "2023-2024",
            },
            ANNEE_2022_2023: {
                ID: "2022_2023",
                TITLE: "Année scolaire 2022-2023",
                UPDATE_THEMES: true,
                THEMES_TEXT: "2022-2023",
            }, 
            ANNEE_2021_2022: {
                ID: "2021_2022",
                TITLE: "Année scolaire 2021-2022",
                UPDATE_THEMES: true,
                THEMES_TEXT: "2021-2022",
            }, 
            ANNEE_2020_2021: {
                ID: "2020_2021",
                TITLE: "Année scolaire 2020-2021",
                UPDATE_THEMES: true,
                THEMES_TEXT: "2020-2021",
            }, 
            ANNEE_2019_2020: {
                ID: "2019_2020",
                TITLE: "Année scolaire 2019-2020",
                UPDATE_THEMES: true,
                THEMES_TEXT: "2019-2020",
            },
        },
        THEMESETS_ELEMENTS: {
            PROVINCIAL: require("configs/themeSetsElements/PROVINCIAL"),
            FREQUENTATION: require("configs/themeSetsElements/FREQUENTATION"),
            RESIDENCE: require("configs/themeSetsElements/RESIDENCE")
        },
        APP_TOOLS: {
            CLIENT_ERRORS_LOGGER: {
                ENABLE: true
            },
        },
        MAP_TOOLS: {
            BASEMAP_TOGGLE: [
                {ID: "carte", BASEMAPLAYERS_IDS: ["Fondstuiles"], INITIAL: false, COPYRIGHTS_IMAGERIE: false},
                {ID: "imagerie", BASEMAPLAYERS_IDS: ["Fondstuiles_2"], INITIAL: false, COPYRIGHTS_IMAGERIE: true},
                {ID: "sobre", BASEMAPLAYERS_IDS: ["Fondstuiles_1"], INITIAL: true, COPYRIGHTS_IMAGERIE: false},
                {ID: "hybride", BASEMAPLAYERS_IDS: ["Fondstuiles", "Fondstuiles_2"], INITIAL: false, COPYRIGHTS_IMAGERIE: true}
            ]
        },
        PANELS: {
            BB_GRAPHS: [
                require("configs/panels/BbGraphs/Provincial_1"),
                require("configs/panels/BbGraphs/Provincial_2"),
                require("configs/panels/BbGraphs/Freq_CS_ANG_ST_1"),
                require("configs/panels/BbGraphs/Freq_CS_FRA_ST_1"),
                require("configs/panels/BbGraphs/Freq_REG_ADM_1"),
                require("configs/panels/BbGraphs/Res_ARRND_1"),
                require("configs/panels/BbGraphs/Res_ARRND_2"),
                require("configs/panels/BbGraphs/Res_ARRND_3"),
                require("configs/panels/BbGraphs/Res_MUNCP_1"),
                require("configs/panels/BbGraphs/Res_MUNCP_2"),
                require("configs/panels/BbGraphs/Res_MUNCP_3"),
                require("configs/panels/BbGraphs/Res_MRC_1"),
                require("configs/panels/BbGraphs/Res_MRC_2"),
                require("configs/panels/BbGraphs/Res_MRC_3"),
                require("configs/panels/BbGraphs/Res_REG_ADM_1"),
                require("configs/panels/BbGraphs/Res_REG_ADM_2"),
                require("configs/panels/BbGraphs/Res_REG_ADM_3"),
            ],
            CONSTAT: require("configs/panels/ConstatConfig"),
        },
        MAP: {
            ID: "map1"
        },
        DEBUG: SERVER === "DEV" ? true : false
    };
});
